import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=418d1e4a&scoped=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=418d1e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418d1e4a",
  null
  
)

export default component.exports